module.exports = "<p>\r\n  error works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/error/error.component.html
// module id = ../../../../../src/app/_components/error/error.component.html
// module chunks = main